/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */

import React, { useState } from 'react';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  InfoWindow,
  OverlayView,
} from 'react-google-maps';
import { Col, Modal, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
// import HotelCard from './HotelCard';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import HotelListCard from './HotelListCard';
import HotelOfflineFilters from './HotelOfflineFilters';
import AppButton from '../../../shared/components/app-button/AppButton';
import { GOOGLE_MAP_KEY } from '../../../saas/AppStorageStaticNames';

const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height / 2),
});

const MapComponent = withScriptjs(
  withGoogleMap(
    ({
      locations,
      selectedLocation,
      onSelectLocation,
      onRoomChoose,
      showInvoiceFare,
      currencyOption,
      conversionRate,
      onShortList,
      intl,
      shortListedHotels,
    }) => (
      <GoogleMap
        defaultZoom={13}
        defaultOptions={{
          mapTypeControl: false,
          fullscreenControl: false,
        }}
        defaultCenter={{
          lat: locations[0].lat,
          lng: locations[0].lng,
        }}
      >
        {locations.map((location, index) => (
          <Marker
            key={index}
            position={{ lat: location.lat, lng: location.lng }}
            onMouseOver={() => onSelectLocation(location)}
            onMouseOut={() => onSelectLocation(null)}
            // onClick={}
            title={location.hn}
            // icon="/images/others/arrow-down.png"
            labelAnchor={new window.google.maps.Point(20, 45)}
            labelStyle={{
              backgroundColor: 'white',
              borderRadius: '20px',
              padding: '5px 10px',
              border: '2px solid blue',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
            label={
              <span
                style={{
                  padding: '5px',
                  backgroundColor: '#fff',
                  color: '#000',
                }}
              >
                {location.hn}
              </span>
            }
            // labelContent={location.hn}
          >
            {selectedLocation === location && (
              <InfoWindow
                onCloseClick={() => onSelectLocation(null)}
                className="hotel-map-view_info-window"
              >
                <HotelListCard
                  intl={intl}
                  hotelData={location}
                  onRoomChoose={onRoomChoose}
                  showInvoiceFare={showInvoiceFare}
                  currencyOption={currencyOption}
                  conversionRate={conversionRate}
                  onShortList={onShortList}
                  shortListedHotels={shortListedHotels}
                />
              </InfoWindow>
            )}
          </Marker>
        ))}
      </GoogleMap>
    ),
  ),
);

function HotelMapView({
  hotelDetails,
  onRoomChoose,
  showInvoiceFare,
  currencyOption,
  conversionRate,
  onShortList,
  shortListedHotels,
  onHideMapView,
  minPrice,
  maxPrice,
  selectedFilters,
  onApplyFilter,
  amenitiesList,
  onClearFilters,
  hotelNames,
  hotelLocations,
  starCount,
}) {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const intl = useIntl();
  const [showFilters, setShowFilters] = useState(true);

  const handleSelectLocation = (location) => {
    setSelectedLocation(location);
  };
  // console.log(hotelDetails);
  const handleApplyFilters = () => {};
  return (
    <Modal
      size="xl"
      show
      fullscreen
      className="hotel-map-modal"
      onHide={onHideMapView}
    >
      <Modal.Header closeButton>Map View</Modal.Header>
      <Modal.Body>
        <div
          style={{ height: '100%', position: 'relative' }}
          className="hotel-map-view d-flex"
        >
          {/* {showFilters && (
            <div
              style={{
                maxWidth: '300px',
                overflowY: 'auto',
                maxHeight: '100%',
              }}
            >
              <HotelOfflineFilters
                minPrice={minPrice}
                maxPrice={maxPrice}
                selectedFilters={selectedFilters}
                onApplyFilter={handleApplyFilters}
                onClearFilters={() => {}}
                hotelLocations={hotelLocations}
                hotelNames={hotelNames}
                starCount={starCount}
                amenitiesList={amenitiesList}
              />
            </div>
          )} */}
          <div
            style={{ maxWidth: '300px', overflowY: 'auto', maxHeight: '100%' }}
          >
            {/* <div>
              <AppButton
                btnText={showFilters ? 'Hide Filters' : 'showFilters'}
                onClick={() => setShowFilters((prev) => !prev)}
              />
            </div> */}
            {hotelDetails.map((location, index) => (
              <HotelListCard
                handleMouseOver={handleSelectLocation}
                handleMouseOut={handleSelectLocation}
                key={index}
                intl={intl}
                hotelData={location}
                onRoomChoose={onRoomChoose}
                showInvoiceFare={showInvoiceFare}
                currencyOption={currencyOption}
                conversionRate={conversionRate}
                onShortList={onShortList}
                shortListedHotels={shortListedHotels}
              />
            ))}
          </div>
          <div className="flex-1">
            <MapComponent
              googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&v=3.exp&libraries=geometry,drawing,places`}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: '100%' }} />}
              mapElement={<div style={{ height: '100%' }} />}
              locations={hotelDetails}
              selectedLocation={selectedLocation}
              onSelectLocation={handleSelectLocation}
              onRoomChoose={onRoomChoose}
              showInvoiceFare={showInvoiceFare}
              currencyOption={currencyOption}
              conversionRate={conversionRate}
              onShortList={onShortList}
              shortListedHotels={shortListedHotels}
              className="hotel-map-view_container"
              intl={intl}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

HotelMapView.propTypes = {
  hotelDetails: PropTypes.array.isRequired,
  onRoomChoose: PropTypes.func.isRequired,
  onShortList: PropTypes.func.isRequired,
  showInvoiceFare: PropTypes.bool.isRequired,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.any.isRequired,
  shortListedHotels: PropTypes.array.isRequired,
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  amenitiesList: PropTypes.array.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  hotelLocations: PropTypes.array.isRequired,
  hotelNames: PropTypes.array.isRequired,
  starCount: PropTypes.any.isRequired,
  onHideMapView: PropTypes.bool.isRequired,
};

export default HotelMapView;
